<template>
  <div
    class="border border-gray-200 rounded-lg shadow-sm divide-y divide-gray-200 text-left overflow-hidden"
  >
    <div 
      class="block w-full h-36 bg-contain bg-center bg-no-repeat relative" 
      style="width: 100%; padding-top: 100%" 
      :style="{'background-image': `url(${productData.featured_image}`}">
      <svg @click="$emit('show-modal')" xmlns="http://www.w3.org/2000/svg" class="h-9 w-9 absolute right-2 top-2 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="white">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <div class="p-6">
      <!--
      <h2 class="text-lg leading-6 font-medium text-gray-900">
        {{ productData.title }}
      </h2>
      <p class="mt-4 text-sm text-gray-500">
        All the basics for starting a new business
      </p>
      <p class="mt-8">
        <span class="text-4xl font-extrabold text-gray-900">{{(productData.price / 100).toString().replace('.',',')}} €</span>
        <span class="text-base font-medium text-gray-500">/mo</span>
      </p>-->
      <a
        @click="added?$emit('remove'):$emit('add')"
        class="cursor-pointer pl-9 mt-0 inline-flex items-center w-full bg-orange border-orange border rounded-md py-2 text-sm font-semibold text-center"
        :class="{'bg-white': !added, 'text-white': added, 'text-orange': !added, 'hover:bg-orange-400': added}"
      >
        <svg
          class="absolute -ml-7 mr-3 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
        zur Box {{ added? 'hinzugefügt' : 'hinzufügen' }}</a
      >
    </div>
    <div class="pt-6 pb-8 px-6">
      <!--
      <h3 class="text-xs font-medium text-gray-900 tracking-wide uppercase">
        Darum optimal für dich
      </h3> -->
      <ul v-if="meta && meta.metafields && meta.metafields.bullets" class="mt-0 space-y-4">
        <li v-for="bullet in meta.metafields.bullets.split(';')" :key="bullet" class="flex space-x-3">
          <!-- Heroicon name: solid/check -->
          <svg
            class="flex-shrink-0 h-5 w-5 text-green-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="text-sm text-gray-500">{{bullet}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductGridItem",
  props: {
    productData: {
      type: Object,
      default() {
        return {};
      },
    },
    meta: {
      type: Object,
      default() {
        return {};
      },
    },
    added: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clicked: false,
      jdgme: "",
    };
  },
  watch: {
    productData: {
      immediate: true,
      handler() {
        fetch(
          "https://judge.me/api/v1/widgets/preview_badge?api_token=JQscx004sYJP2RuPNe7VqDZt6ZY&shop_domain=gloryfeel.myshopify.com&external_id=" +
            this.productData.id
        )
          .then((response) => response.json())
          .then((data) => (this.jdgme = data.badge));
      },
    },
  },
  methods: {
    add2cart() {
      this.clicked = true;
      fetch("/cart/add.js", {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify({ id: this.productData.variants[0].id }), // body data type must match "Content-Type" header
      });
    },
  },
};
</script>